<template>
  <v-card-text>
    <div class="text-xs-right">
      <v-btn icon flat @click="handleClose"><v-icon>close</v-icon></v-btn>
    </div>
    <div class="text-xs-center">
      <div class="mb-2" style="display: flex; justify-content: center; align-items: center">
        <div class="pa-1">
          <img
            src="/static/img/assets/allow-chatgpt/chat_gpt_logo.png"
            alt
            class="responsive-img"
          />
        </div>
        <div class="pa-1">
          <img src="/static/img/assets/allow-chatgpt/two_arrow.png" alt class="responsive-img" />
        </div>
        <div class="pa-1">
          <img src="/static/img/assets/allow-chatgpt/zwiz_logo.png" alt class="responsive-img" />
        </div>
      </div>
      <div class="headline">ต้องการใช้งาน Recommended sentence จาก ChatGPT หรือไม่?</div>
      <div class="mb-2">ระบบจะทำการแนะนำบทสนทนาที่ใกล้เคียงกัน จาก ChatGPT</div>
    </div>
    <div class="text-xs-center">
      <v-btn class="skip-btn" depressed @click="handleSkip">ข้าม</v-btn>
      <v-btn color="primary" @click="handleAllow">ค้นหา</v-btn>
    </div>
  </v-card-text>
</template>

<script>
export default {
  methods: {
    handleClose() {
      this.$emit('onClose')
    },
    handleAllow() {
      this.$emit('onAllow')
    },
    handleSkip() {
      this.$emit('onSkip')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/DialogAllowUseChatGpt.vue